import { useEffect, useRef, useState } from 'react';
import './Video.scss';
import ReactPlayer from 'react-player';
import { useNavigate } from 'react-router-dom';
import { data as videoData } from '../../data/data';

const VideoComponent = ({ onInteractionDetected, elementId, clickedItemId }) => {
  const [videoPlayerReady, setVideoPlayerReady] = useState(false);
  const [currentVideoTime, setCurrentVideoTime] = useState(0);
  const [lock, setLock] = useState(true);

  const player = useRef(null);
  const navigate = useNavigate();

  const data = videoData;

  useEffect(() => {
    const onParamChange = () => {
      const result = data.find((item) => item.elementId === elementId);

      if (lock) return;

      if (elementId) {
        setCurrentVideoTime(result.start);
        if (result.start <= currentVideoTime && currentVideoTime >= result.end) {
          player.current.seekTo(result.start, 'seconds');
        }
      }

      onInteractionDetected({});

      setTimeout(() => {
        if (result) {
          onInteractionDetected(result);
        } else if (!result) {
          onInteractionDetected({});
        }
      }, 1000);
    };
    onParamChange();
  }, [elementId]);

  useEffect(() => {
    if (clickedItemId !== 0) {
      const result = data.find((item) => item.elementId === clickedItemId);
      if (result) {
        player.current.seekTo(result.start, 'seconds');
        setTimeout(() => {
          onInteractionDetected(result);
          setLock(false);
        }, 1000);
      }
    }
  }, [clickedItemId]);

  const checkFirstParameter = () => {
    const result = data.find((item) => item.elementId === elementId);
    if (result) {
      player.current.seekTo(result.start, 'seconds');
      setTimeout(() => {
        onInteractionDetected(result);
        setLock(false);
      }, 1000);
    } else {
      onInteractionDetected({});
      setLock(false);
    }
  };

  const onVideoDataChange = (timeNumber) => {
    setCurrentVideoTime(timeNumber);
    if (lock) return;

    const result = data.find((item) => item.start <= Math.round(currentVideoTime) && Math.round(currentVideoTime) <= item.end);
    if (result) {
      navigate(`/${result.elementId}`);
    } else {
      navigate('/');
    }
  };

  return (
    <div className='Video' id='video'>
      {console.log(videoPlayerReady)}
      <ReactPlayer
        ref={player}
        style={videoPlayerReady ? { visibility: 'visible' } : { visibility: 'hidden' }}
        controls
        playing
        playsinline
        muted
        width='100%'
        height='100%'
        url='https://player.vimeo.com/external/507006883.hd.mp4?s=1478354b5c1cfe1731a80812bc204a1622f23641&profile_id=175'
        onProgress={(timeData) => {
          onVideoDataChange(timeData.playedSeconds);
        }}
        onSeek={(seconds) => {
          onVideoDataChange(seconds);
        }}
        onReady={() => {
          setVideoPlayerReady(true);
        }}
        onStart={() => {
          checkFirstParameter();
        }}
        config={{
          file: {
            attributes: {
              controlsList: 'nofullscreen'
            }
          }
        }}
      />
    </div>
  );
};

export default VideoComponent;
